import React from 'react';
import { Investment } from '@/types/investment';

interface OverviewProps {
  investment: Investment;
}

const Overview: React.FC<OverviewProps> = ({ investment }) => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-foreground">Investment Overview</h2>
      <p className="text-base text-muted-foreground">{investment.description}</p>
      
      

      {investment.ratesTable && (
        <>
          <h3 className="text-xl font-semibold text-foreground">Indicative Rates</h3>
          <div className="overflow-x-auto not-prose">
            <table className="min-w-full border-collapse text-left">
              <thead>
                <tr>
                  {investment.ratesTable.headers.map(header => (
                    <th key={header} scope="col" className="px-6 py-4 text-sm font-semibold text-foreground bg-muted border-b border-border">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {investment.ratesTable.rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                      <td key={cellIndex} className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground">
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default Overview;
